import { Scroll } from "@/lib/scroll";
import { onMount, onDestroy } from "@/modules/_";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  onMount(() => {
    const baseLag = 0.5;
    const lagScale = 0.1;

    gsap.set(element.children, { willChange: "transform" });
    const groupItemsByColumn = () => {
      const gridStyles = window.getComputedStyle(element);
      const columnsRaw = gridStyles.getPropertyValue("grid-template-columns");

      const numColumns = columnsRaw.split(" ").filter(Boolean).length;

      const mid = (numColumns - 1) / 2;

      // Distribute grid items into column buckets
      element.querySelectorAll(".w-dyn-item").forEach((item, index) => {
        const column = index % numColumns;
        const distance = Math.abs(column - mid);

        (item as HTMLElement).dataset.column = String(
          baseLag + distance * lagScale
        );
      });
    };

    groupItemsByColumn();

    window.addEventListener("resize", groupItemsByColumn);

    const cleanup = () => {
      window.removeEventListener("resize", groupItemsByColumn);
    };

    (element as any)._gridCleanup = cleanup;

    Scroll.on("scroll", (scroll) => {
      if (window.innerWidth < 768) return;

      let smoothedVelocity = 0;
      const targetVelocity = scroll.velocity;

      smoothedVelocity = gsap.utils.interpolate(
        smoothedVelocity,
        targetVelocity,
        0.6
      );

      // console.log(Math.max(smoothedVelocity, -5));

      gsap.to(element.children, {
        y: (i) => {
          const item = element.children[i] as HTMLElement;
          const speedFactor = Number(item.dataset.column);

          return Math.max(smoothedVelocity, -5) * (15 * speedFactor);
        },
        ease: "power3",
        overwrite: true,
        duration: 0.5,
      });
    });
  });

  onDestroy(() => {
    // Call cleanup if it exists
    const cleanup = (element as any)._menuCleanup;
    if (cleanup) {
      cleanup();
    }
  });
}
